// external-access-api.js
import { ProtectedHttpClient } from "../shared/clients/http-client";

const ExternalAccessApi = {
  private: {
    // Live mode API key
    createApiKey: () => ProtectedHttpClient.post("/external-access"), // Requires token
    getApiKey: () => ProtectedHttpClient.get("/external-access"), // Requires token

    // Sandbox mode API key
    createSandboxApiKey: () => ProtectedHttpClient.post("/external-access", { accessType: "sandbox" }), // Requires token
    getSandboxApiKey: () => ProtectedHttpClient.get("/external-access?accessType=sandbox"), // Requires token

    // Sandbox stats
    getSandboxStats: () => ProtectedHttpClient.get("/sandbox-config/stats"), // Requires token

    // Webhook (Live mode only)
    getWebhook: () => ProtectedHttpClient.get("/external-access?accessType=webhook"), // Requires token
    createWebhook: (webhookData) => ProtectedHttpClient.post("/external-access", {
      accessType: "webhook",
      ...webhookData
    }), // Requires token
    updateWebhook: (id, webhookData) => ProtectedHttpClient.patch(`/external-access/${id}`, webhookData), // Requires token
    deleteWebhook: (id) => ProtectedHttpClient.delete(`/external-access/${id}`), // Requires token
  },
};

export default ExternalAccessApi;
